import styled from "styled-components";
import NumberInput from "react-number-input"

export const InputQt = styled.input`
border: none;
  ${({ aceitaDec }) => {
    if (aceitaDec) {
      return `
        width:140px;
        margin-left: 0px;
        border: 1px solid #999;
        border-radius: 4px;
      `
    } else {
      return "width:39px; border : none;margin-left: 5px;"
    }
  }} 
  height: 30px;
  text-align: center;
  padding: 5px;
  font-size: 16px;
  display: inline-block; 
  margin-top: -4px;
  outline : none;
`


export const ColumnContainer = styled.div`
  display: flex;
  flex-direction :column;
  & > span {
    margin-bottom: 10px
  }
`